<template>
  <main-layout>
    <lecon :niveau="niveau"></lecon>
    <a :href="imageProps.link">
      <b-img :src="getImg()" :alt="imageProps.img"></b-img>
    </a>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import Lecon from "@/components/Lecon/lecon";

const pub = {
  b1: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B1.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B1_mini.jpg",
    link     : "https://www.luqei.com/b1.php?landing=TRUE"
  },
  b2: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B2.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B2_mini.jpg",
    link     : "https://www.luqei.com/b2.php?landing=TRUE"
  },
  c1: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_C1.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_C1_mini.jpg",
    link     : "https://www.luqei.com/c1.php"
  },
  c2: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_mini.jpg",
    link     : "https://www.luqei.com/c2.php?landing=TRUE"

  }
}

export default {
  name      : "LeconVue",
  components: {Lecon, MainLayout},
  data() {
    const niveau = this.$route.params.niveau;
    return {
      niveau,
      imageProps: {
        ...pub[niveau]
      }
    }
  },
  watch  : {
    "$route.params.niveau": function (nV) {
      this.niveau = nV;
      this.imageProps = {
        ...pub[nV]
      }
    }
  },
  methods: {
    getImg() {
      return this.imageProps[screen.width < 576 ? 'imgMobile' : 'img']
    }
  }

}
</script>

<style scoped>
img {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  display: block;
}
</style>